export default Object.freeze({
  PLAYLIST_FRAME_MUTE_VOLUME: 0.1,
  PLAYLIST_SKIP_INTERVAL_SEC: 30,
  CALL_TICKET_DURATION: 5000,
  INFOBOARD_BACKGROUND_COLOR_DEFAULT: '#34c759',
  INFOBOARD_BACKGROUND_COLOR_MAIN_DEFAULT: '#ffffff',
  INFOBOARD_TICKET_NUMBER_COLOR_DEFAULT: '#ffffff',
  INFOBOARD_WINDOW_COLOR_DEFAULT: '#1c1c1e',
  INFOBOARD_NEW_TEMPLATE_DESIGN_DEFAULT: false,
  WEATHERMAP_API_KEY: '1e6408add4d02764c87a436302fc4903',
  CANCEL_AUDIO_CALL_TICKET_TIMEOUT: 15
});

export const ISSUING_STAGE_TRANSLATIONS = Object.freeze({
  WAITING: 'infoscreen_issuing_waiting',
  ASSEMBLING: 'infoscreen_issuing_assembling',
  READIED: 'infoscreen_issuing_readied',
})

export const CYCLE_PERIOD_SECONDS = Object.freeze({
  GroupByOrder: 10,
  GroupNoIssued: 4,
})

export const TICKET_CHUNK_SIZES = Object.freeze({
  GroupByOrder: 6,
  GroupNoIssued: 1,
})

export const TICKET_STATUS = Object.freeze({
  CLOSED: 'closed',
  WAITING: 'waiting',
  POSTPONED: 'postponed',
  CANCELED: 'canceled',
  REDIRECTED: 'redirected',
  READIED: 'ready'
})
